// Values must match the API's JSON casing (JsonStringEnumConverter with CamelCase naming policy).
export enum SnapshotScope {
    Remediation = 'remediation',
    Vendor = 'vendor',
    Portfolio = 'portfolio',
}
